import { EDecision, EFinancingProgram } from '@if/core/types'
import { Typography } from '@mui/material'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'
import CreditAlertMessage from './CreditAlertMessage'

interface Props {
  creditApp: CreditApplication
}

const RequiresIntervention = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  const applicantAlerts = creditApp.applicant.creditAlerts
  const coapplicantAlerts = creditApp.coApplicant?.creditAlerts
  const shouldShowProductPreviousApplicationWarning =
    creditApp.financingProgramId === EFinancingProgram.Products &&
    applicantAlerts?.hasPreviousApplication &&
    creditApp.normsCreditDecision?.decision === EDecision.Approved

  const shouldShowNormalPreviousApplicationWarning =
    shouldShowProductPreviousApplicationWarning === false && applicantAlerts?.hasPreviousApplication
  if (!applicantAlerts && !coapplicantAlerts) {
    return null
  }

  return (
    <>
      <CreditAlertMessage
        applicantAlerts={applicantAlerts}
        coapplicantAlerts={coapplicantAlerts}
        warningId="hasNameMismatch"
        warningMessage={t('viewCreditApplication.nameMismatch')}
      />

      {shouldShowProductPreviousApplicationWarning && (
        <Typography variant="body1">{t('viewCreditApplication.previousAppConditionnalApprobation')}</Typography>
      )}

      {shouldShowNormalPreviousApplicationWarning && (
        <Typography variant="body1">{t('viewCreditApplication.previousApp')}</Typography>
      )}

      <CreditAlertMessage
        applicantAlerts={applicantAlerts}
        coapplicantAlerts={coapplicantAlerts}
        warningId="hasCreditLocked"
        warningMessage={t('viewCreditApplication.creditLocked')}
      />

      <CreditAlertMessage
        applicantAlerts={applicantAlerts}
        coapplicantAlerts={coapplicantAlerts}
        warningId="hasInvalidCity"
        warningMessage={t('viewCreditApplication.invalidCity')}
      />

      <CreditAlertMessage
        applicantAlerts={applicantAlerts}
        coapplicantAlerts={coapplicantAlerts}
        warningId="hasGeneralCreditReportError"
        warningMessage={t('viewCreditApplication.generalCreditReportError')}
      />

      <CreditAlertMessage
        applicantAlerts={applicantAlerts}
        coapplicantAlerts={coapplicantAlerts}
        warningId="isBanned"
        warningMessage={t('viewCreditApplication.bannedApplicant')}
      />
    </>
  )
}

export default RequiresIntervention
